import React, { useEffect } from "react";
import { InlineWidget } from "react-calendly";
import { useNavigate } from "react-router-dom";
import CommonDialog from "./CommonDialog";

export default function CommonBookSession({
  bookingUrl,
  open,
  studentName,
  email,
  handleClose,
  setOpen
}) {
  const navigate = useNavigate();

  useEffect(() => {
    function handleCalendlyEvent(e) {
      if (e.data.event === "calendly.event_scheduled" || e.data.event === "calendly.event_rescheduled") {
        if (handleClose) {
          handleClose(e.data);
        } else {
          navigate(`/intake-form?uri=${e.data.payload?.invitee?.uri}`);
        }
      }
    }

    window.addEventListener("message", handleCalendlyEvent);

    return () => {
      window.removeEventListener("message", handleCalendlyEvent);
    };
  }, [navigate]);

  return (
    <CommonDialog
      open={open}
      onClose={() => setOpen(false)}
      content={
        <InlineWidget
          url={bookingUrl}
          prefill={{
            name: studentName,
            email: email,
          }}
        />
      }
    />
  );
}